import { forwardRef, useImperativeHandle, useRef } from 'react';
import { InboxOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import { StyledDragger } from 'components/new-ui/base/dragger/styles';
import { DraggerProps } from 'antd/lib/upload';

interface Props extends DraggerProps {
    title?: string;
    subtitle?: string;
}

export interface UploadDocumentsRef {
    triggerUpload: () => void;
}

const UploadDocuments = forwardRef<UploadDocumentsRef, Props>(
    ({ title = 'Click or drag file to this area to upload', subtitle, ...rest }, ref) => {
        const draggerContainerRef = useRef<HTMLDivElement | null>(null);

        useImperativeHandle(ref, () => ({
            triggerUpload: () => {
                const input = draggerContainerRef.current?.querySelector(
                    'input[type="file"]'
                ) as HTMLInputElement | null;
                if (input) {
                    input.click();
                } else {
                    console.warn('File input not found.');
                }
            },
        }));

        return (
            <div ref={draggerContainerRef}>
                <StyledDragger {...rest}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: 16,
                        }}
                    >
                        <InboxOutlined
                            style={{
                                fontSize: 36,
                                color: 'var(--brand-6)',
                            }}
                        />
                        <div>
                            <Typography style={{ fontSize: 16, lineHeight: '24px' }}>{title}</Typography>
                            {subtitle && <Typography style={{ color: 'var(--gray-7)' }}>{subtitle}</Typography>}
                        </div>
                    </div>
                </StyledDragger>
            </div>
        );
    }
);

export default UploadDocuments;
